interface Environment {
    CMS_URL: string;
    FILE_MAKER_API: string;
    CMS_MEDIA_URL: string;
    NODE_ENV: string;
    BRAND_LABEL: string;
}

const DEFAULT_VALUES = {
    BRAND_LABEL: "carconnex",
};

interface EnvironmentKeys extends Environment {
    [key: string]: string;
}

function mapEnvProperties() {
    const env = {} as EnvironmentKeys;
    for (const key of Object.keys(process.env)) {
        env[key.replace("VUE_APP_", "")] = process.env[key] || "";
    }

    console.log(process.env);
    return env;
}

const env: EnvironmentKeys = mapEnvProperties();

export function getEnvValue(key: keyof Environment) {
    return env[key] || DEFAULT_VALUES[key];
}

export default env;
